// extracted by mini-css-extract-plugin
module.exports = {"container":"Headline_container__1VNEM Div_Div__38Xlj","title":"Headline_title__RFq2q","headline":"Headline_headline__3ZYvF"};